<template>
  <div class="user-info__content"
    :class="{ 'require-password': isShowPasswordChecker }">
    <user-info-menu
      :routeName="getRouteName"
      @showCouponLayer="isShowCouponLayer = true" />

    <app-header>
      <user-info-summary slot="extra" />
    </app-header>

    <password-checker v-if="isShowPasswordChecker"/>
    <router-view v-else/>

    <dimmed v-if="useDimmed">
      <coupon
        v-if="isShowCouponLayer"
        @closeLayer="isShowCouponLayer = false"/>
    </dimmed>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { parse, isBefore } from 'date-fns'
import { storageManager, STORAGE_KEY } from '@/libs/storage-manager'
import AppHeader from '@/components/header'
import UserInfoSummary from '@/components/header/UserInfoSummary'
import UserInfoMenu from '@/components/user-info/UserInfoMenu'
import PasswordChecker from '@/components/user-info/PasswordChecker'
import Dimmed from '@/components/ui/Dimmed'
import Coupon from '@/components/user-info/Coupon'

export default {
  components: {
    AppHeader,
    UserInfoSummary,
    UserInfoMenu,
    Dimmed,
    Coupon,
    PasswordChecker
  },
  data () {
    return {
      isShowCouponLayer: false,
      isShowPasswordChecker: true
    }
  },
  computed: {
    ...mapState([
      'userData',
      'myInfoTimestamp'
    ]),
    useDimmed () {
      return this.isShowCouponLayer
    },
    getRouteName () {
      return this.$route.name
    }
  },
  watch: {
    myInfoTimestamp (value) {
      this.checkMyInfoAuth()
    }
  },
  created () {
    this.checkMyInfoAuth()
  },
  methods: {
    ...mapMutations([
      'setMyInfoTimestamp'
    ]),
    checkMyInfoAuth (route) {
      const targetRoute = route || this.$route
      this.isShowPasswordChecker = true
      const isTargetPage = targetRoute.meta.requireMyInfoAuth

      if (!isTargetPage) {
        this.isShowPasswordChecker = false
        return
      }

      let expireTimestamp = this.myInfoTimestamp

      if (!expireTimestamp) {
        expireTimestamp = storageManager.getItem(STORAGE_KEY.myInfoTimestamp)
        this.setMyInfoTimestamp(expireTimestamp)
      }

      if (isTargetPage && expireTimestamp) {
        const expireDate = parse(expireTimestamp)
        const now = new Date()

        if (isBefore(now, expireDate)) {
          this.isShowPasswordChecker = false
        } else {
          this.setMyInfoTimestamp(null)
        }
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.checkMyInfoAuth(to)
    next()
  }
}
</script>

<style lang="scss" scoped="scoped">
.user-info__content {
  &.require-password {
    position: relative;
  }
  .header--wrap {
    z-index: 9999999;
    position: relative;
    float: left;
    left: 2px;
    top: 0;
    width: calc(100% - 213px);
    background-color: #f4f4f1;
    padding-left: 28px;
    padding-right: 30px;
    box-sizing: border-box;
  }

  /deep/ .btn__back-to-top {
    position: relative;
    float: right;
    padding-bottom: 25px;
  }
}
</style>
